<template>
  <a-modal
    title="选择京东联盟"
    :width="900"
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
    :bodyStyle="{}"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="京东联盟账户">
              <a-input v-model="queryParam.keywords" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <template v-if="advanced"></template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table ref="table" rowKey="id" :columns="columns" :data="loadData">
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <div slot="remarks_text" slot-scope="text, record">{{record.remark?record.remark:'无'}}</div>
      <template slot="action" slot-scope="text,record">
        <a @click="onchange(record)">选择</a>
      </template>
    </s-table>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: '序号',
    scopedSlots: { customRender: 'serial' },
    width: 60
  },
  {
    title: '京东联盟ID',
    dataIndex: 'union_id'
  },
  {
    title: '备注信息',
    scopedSlots: { customRender: 'remarks_text' }
  },
  {
    title: '操作',
    width: 60,
    scopedSlots: { customRender: 'action' }
  }
]
import CompanyApi from '@/api/company'
import { STable } from '@/components'
export default {
  components: {
    STable
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      columns,
      loading: false,
      visible: false,
      currentRobotId: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return CompanyApi.getJingdongList(Object.assign(parameter, this.queryParam))
      }
    }
  },
  created() {},
  methods: {
    show() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    onchange(record) {
      this.$emit('change', record)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
